export class S3FileSampleStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "distinctPerField",
            "baseName": "distinctPerField",
            "type": "{ [key: string]: number; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3FileSampleStats.attributeTypeMap;
    }
    constructor() {
    }
}
